import React, {useState, useEffect} from 'react';
import './onboardingSidebar.scss';
import {Progress} from 'reactstrap';
import {toggleMobileMenu} from "../../redux/actions/AuthAction";
import {connect} from "react-redux";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle, faCheckCircle} from '@fortawesome/free-solid-svg-icons';

const OnboardingSidebar = ({showMobileMenu, accountIndicator, progressbar}) => {
    const [progress, setProgress] = useState(0);
    const [steps, setSteps] = useState(0);
    const [secondary, setSecondary] = useState(0);
    useEffect(() => {
        if (progressbar) {
            setSecondary(false);
            const completedProgress = progressbar.reduce((result, step) => {
                const key = step.slug;
                result[key] = step.completed;
                return result;
            }, {});
            setSteps(completedProgress);

            let totalSteps = progressbar.length;
            let completed = 0;
            progressbar.map((answer, i) => {
                if (answer.slug === 'secondary_owner') {
                    setSecondary(true);
                }
                if (answer.slug === 'primary_owner' || answer.slug === 'secondary_owner') {
                    if(answer.completed === true){
                        completed++;
                    } else {
                        let total = answer.steps.length;
                        let count = 0;
                        answer.steps.map((val, i) => {
                            if (val.completed === true || val.skipped === true) {
                                count++;
                            }
                        });
                        let added = Math.round((count / total) * 10) / 10;
                        completed = completed + added;
                    }
                } else if (answer.completed === true) {
                    completed++;
                }
            });
            let percentage = (completed / totalSteps) * 100;
            if (totalSteps === 9) {
                setProgress(Math.round(percentage / 10) * 10);
            } else {
                setProgress(Math.round(percentage));
            }
        }
    }, [progressbar]);


    const changeNavigation = (val) => {
        localStorage.setItem('navigation', val);

    };

    return (
        <div className={`onboarding-sidebar-panel  ${!showMobileMenu ? 'hide-mobile' : ''}`}>
            <nav>
                <a href='#/'>
                    <img src="/logo-full.png" alt="Myra"/>
                </a>
            </nav>
            {
                steps &&
                <React.Fragment>
                    <div className="invest-set-up">
                        <h5>{steps.verify_phone ? 'INVEST' : 'ACCOUNT'} SETUP</h5>
                        <Progress value={progress}/>
                        <div className="text-left">{progress}% Complete</div>
                    </div>
                    <ul>
                        <li>
                            <span className="check">
                                <FontAwesomeIcon icon={faCheckCircle}/>
                            </span>
                            1. Verify Email
                        </li>
                        <li>
                            <span className={steps.verify_phone ? 'check' : 'empty'}>
                                {steps.verify_phone && <FontAwesomeIcon icon={faCheckCircle}/>}
                            </span>
                            {steps.verify_phone}
                            2. Verify Phone
                        </li>
                        {steps.verify_email && steps.verify_phone ?
                            <React.Fragment>
                                <li onClick={() => changeNavigation('select')}>
                                    <span className={steps.select ? 'check' : 'empty'}>
                                        {steps.select && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    3. Select Account
                                </li>
                                <li onClick={() => changeNavigation('risk')}>
                                    <span className={steps.risk ? 'check' : 'empty'}>
                                        {steps.risk && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    4. Risk Profile
                                </li>
                                <li onClick={() => changeNavigation('portfolio')}>
                                    <span className={steps.portfolio ? 'check' : 'empty'}>
                                        {steps.portfolio && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    5. Portfolio Allocation
                                </li>
                                <li onClick={() => changeNavigation('fund')}>
                                    <span className={steps.fund ? 'check' : 'empty'}>
                                        {steps.fund && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    6. Fund Account
                                </li>
                                <li onClick={() => changeNavigation('primary')}>
                                    <span className={steps.primary_owner ? 'check' : 'empty'}>
                                        {steps.primary_owner && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    7. Primary Owner
                                </li>
                                <li onClick={() => changeNavigation('secondary')}>
                                    {!secondary ?
                                        <span className="close">
                                            <FontAwesomeIcon icon={faTimesCircle}/>
                                        </span>
                                        :
                                        <span className={steps.secondary_owner ? 'check' : 'empty'}>
                                            {steps.secondary_owner && <FontAwesomeIcon icon={faCheckCircle}/>}
                                        </span>
                                    }
                                    8. Secondary Owner
                                </li>
                                <li onClick={() => changeNavigation('sign')}>
                                    <span className={steps.sign ? 'check' : 'empty'}>
                                        {steps.sign && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    9. Sign & Submit
                                </li>
                                <li onClick={() => changeNavigation('refer')}>
                                    <span className={steps.refer ? 'check' : 'empty'}>
                                        {steps.refer && <FontAwesomeIcon icon={faCheckCircle}/>}
                                    </span>
                                    10. Refer A Friend
                                </li>
                                {steps.sign &&
                                <li className="mt-4">
                                    <button className="custom-btn-primary">
                                        GO TO DASHBOARD
                                    </button>
                                </li>
                                }
                            </React.Fragment>
                            : null
                        }

                    </ul>
                </React.Fragment>
            }

        </div>
    )
};

const mapStateToProps = state => ({
    showMobileMenu: state.Auth.showMobileMenu,
    accountIndicator: state.Account.accountIndicator,
    progressbar: state.Account.progressbar
});

const mapDispatchToProps = dispatch => ({
    toggleMobileMenu: payload => {
        dispatch(toggleMobileMenu(payload))
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OnboardingSidebar);
